// toast.service.ts
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface ToastMessage {
  id: number;
  text: string;
  type?: 'success' | 'error' | 'info';
}

@Injectable({ providedIn: 'root' })
export class ToastService {
  private _messages = new BehaviorSubject<ToastMessage[]>([]);
  messages$ = this._messages.asObservable();

  private counter = 0;

  show(text: string, type: ToastMessage['type'] = 'info', duration = 3000) {
    const id = ++this.counter;

    const newMessage: ToastMessage = { id, text, type };

    this._messages.next([...this._messages.value, newMessage]);

    setTimeout(() => this.remove(id), duration);
  }

  remove(id: number) {
    this._messages.next(this._messages.value.filter((m) => m.id !== id));
  }
}